import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PageMenu from '../../../blocks/PageMenu/PageMenu';
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";
import useDecode from "hooks/useDecode";
import ManagementFormCardList from 'components/blocks/ManagementNewForms/CardList/ManagementFormCardList';
import Loader from "components/blocks/Loader/Loader";
import ErrorDisplay from "components/blocks/ManagementNewForms/ErrorManagement/ErrorPantalla";
import FormularioCertificadoEmpresa from "./FormularioCertificadoEmpresa";
import useGetCertificadoEmpresaItByUser from "services/record/CertificadoEmpresa/useGetCertificadoEmpresaItByUser";
import useGetInfoCertificadoEmpresaIt from "services/record/CertificadoEmpresa/useGetInfoCertificadoEmpresaIt";
import useGetCertificadoEmpresaItByID from "services/record/CertificadoEmpresa/useGetCertificadoEmpresaItByID";

const GridFormularioCertificadoEmpresa = ({ expedienteId = null, origen = null }) => {

    const { dataGetCertificadoEmpresaItByUser, getCertificadoEmpresaItByUser, successGetCertificadoEmpresaItByUser, loadingGetCertificadoEmpresaItByUser } = useGetCertificadoEmpresaItByUser()
    const { getCertificadoEmpresaById, loadingGetCertificadoEmpresaById } = useGetCertificadoEmpresaItByID();
    const { getInfoCertificadoEmpresaIt, loadingGetInfoCertificadoEmpresaIt } = useGetInfoCertificadoEmpresaIt()
    const title = 'Formulario Certificado de Empresa' // CAMBIAR TITULO
    const navigate = useNavigate();

    /// OBTENER TOKEN PARA LAS PETICIONES ///
    const tokenResponse = useDecode("token");
    const userId = tokenResponse?.extension_id;
    
    const expedienteIdByOrigen = Number(origen) === 1 ? (expedienteId ?? null) : null;
    const dataUserWithExpedienteByOrigen = (data) => (expedienteIdByOrigen !== null && expedienteIdByOrigen !== undefined ? { ...data, ExpedienteId: expedienteIdByOrigen } : data);

    const [arrData, setArrData] = useState(null)
    const [dataUser, setDataUser] = useState(null);
    const [info, setInfo] = useState(false);
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [showGenerateButton, setShowGenerateButton] = useState(true);
    const [generateKey, setGenerateKey] = useState(0);

    const rowSelected = (args) => { // SELECCIONAR UN FORMULARIO E IMPRIMIRLO
        setInfo(false)
        setLoading(true)
        setShow(false)
        setTimeout(() => { //Darle tiempo actualizar el DOM
            setShow(true)
            setLoading(false)
        }, 200);

        getCertificadoEmpresaById(args.data.UsuarioId, args.data.PrestacionId, args.data.Id, setDataUser)
    };
    useEffect(() => {
        getCertificadoEmpresaItByUser(userId, expedienteIdByOrigen) // OBTENER FORMULARIOS PARA LA TABLA
    }, [])

    useEffect(() => {
        if (successGetCertificadoEmpresaItByUser) {
            setArrData(dataGetCertificadoEmpresaItByUser);
        }
    }, [dataGetCertificadoEmpresaItByUser]);

    const handleInfo = () => {
        setGenerateKey(prev => prev + 1); //OBTENER INFORMACION EN EL BOTON
        setLoading(true)
        setInfo(true)
        setShow(false)

        // setDataUser({
        //     DatosEmpresa: {
        //         EmpresaNombre: "ACME Industrias S.L.",
        //         EmpresaCCC: "01234567890123456789",
        //         EmpresaProvincia: "28",
        //         EmpresaProvinciaDescripcion: "Madrid",
        //         EmpresaDomicilio: "Calle Falsa 123, 4ºB",
        //         EmpresaCodigoPostal: "28013",
        //     },
        //     DatosPersonales: {
        //         SolicitanteNombre: "María",
        //         SolicitanteApellido1: "López",
        //         SolicitanteApellido2: "García",
        //         SolicitanteIPF: "12345678A",
        //         SolicitanteIPFTipo: "1",
        //         SolicitanteTelefono: "600123456",
        //         SolicitanteFijo: "915123456",
        //         SolicitanteDomicilio: "Av. de América 45, 2ºA",
        //         SolicitanteCodigoPostal: "28002",
        //         SolicitanteProvincia: "28",
        //         SolicitanteProvinciaDescripcion: "Madrid",
        //     },
        //     DatosTrabajador: {
        //         TrabajadorContratoTiempoParcial: true,
        //         TrabajadorSeguridadSocial: "789012345678",
        //         TrabajadorGrupoCotizacion: "3",
        //         TrabajadorFechaAltaEmpresa: "2024-02-15T00:00:00.000Z",
        //         TrabajadorFechaBajaEmpresa: null,
        //         TrabajadorFechaBajaMedica: null,
        //         TrabajadorFechaAbonoIT: null,
        //         CausaBajaMedica: "",
        //         TrabajadorCausaExticionPagoDirecto: "",
        //         TrabajadorFechaVacacionesDesde: "2025-07-01T00:00:00.000Z",
        //         TrabajadorFechaVacacionesHasta: "2025-07-15T00:00:00.000Z",
        //         TrabajadorVacacionesBase: "450.00",
        //         TrabajadorTipoContrato: "Temporal",
        //         TrabajadorTipoContratoDescripcion: "Contrato de obra y servicio",
        //     },
        // })
        //Agregar el Get Necesario
        getInfoCertificadoEmpresaIt(userId, (data) => setDataUser(dataUserWithExpedienteByOrigen(data))) //Agregar el Get Necesario
        if (dataUser) {
            setTimeout(() => { //Darle tiempo actualizar el DOM
                setShow(true)
                setLoading(false)
            }, 500);
        }
    }

    useEffect(() => { // CUANDO CAMBIA DATAUSER SE RECARGA EL FORMULARIO
        setLoading(true)
        setShow(false)
        setTimeout(() => {//Darle tiempo actualizar el DOM
            setShow(true)
            setLoading(false)
        }, 200);
    }, [dataUser]);


    useEffect(() => {
        if (arrData && Array.isArray(arrData)) {
            const hasFormZero = arrData.some(item => item.EstadoFormulario === 0);
            setShowGenerateButton(!hasFormZero);
        }
    }, [arrData]);

    return (
        <div className="container bg-#EEEEEE management-new-forms-typography">
            <PageMenu title={title} >
                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>
            <ManagementFormCardList dataSource={arrData || []} onSelect={rowSelected} key={generateKey} />
            {showGenerateButton && (
                <div className="container">
                    <div className="delta-buttons c-right">
                    <button className="btn-box btn-accent" onClick={() => handleInfo()}>
                        Generar Formulario
                    </button>
                    </div>
                </div>
            )}
            <Loader activeLoader={
                loading
                ||
                loadingGetCertificadoEmpresaById
                ||
                loadingGetCertificadoEmpresaItByUser
                ||
                loadingGetInfoCertificadoEmpresaIt
                } label="Cargando Formulario"></Loader>
            {dataUser && (dataUser?.BoolResultado !== false) && show && (
                <div className="mt-5">
                    <FormularioCertificadoEmpresa
                        dataUser={dataUser}
                        info={info} />
                </div>
            )}
            {dataUser && show && dataUser?.BoolResultado === false &&
                <ErrorDisplay descripcionError={dataUser.Descripcion} />
            }

        </div>
    );
};
export default GridFormularioCertificadoEmpresa;
